import { format } from "date-fns";
import { getClientStatus, getStatusStyles } from "../utils/statusUtils";
import { useNavigate } from "react-router-dom";
import { Button } from "@/components/ui/button";

interface ClientPaymentTableProps {
  clients: Array<{
    clientId: number;
    clientName: string;
    totalAgreed: number;
    companyTotal: number;
    firstPaymentDate: string;
    currentMonth: number;
    status: string;
    documents?: any[];
    notes?: string;
    paymentPlan?: any;
  }>;
  type: 'potential' | 'active';
}

export const ClientPaymentTable = ({ clients, type }: ClientPaymentTableProps) => {
  const navigate = useNavigate();

  if (!clients.length) {
    return (
      <tr>
        <td colSpan={6} className="text-center p-4 text-gray-400">
          No {type === 'potential' ? 'potential' : 'active'} clients found
        </td>
      </tr>
    );
  }

  const handleClientClick = (clientId: number) => {
    navigate(`/admin/clients/${clientId}`);
  };

  return (
    <>
      {clients.map((client) => {
        const status = getClientStatus(client);
        const statusStyles = getStatusStyles(status);
        
        return (
          <tr key={client.clientId} className="border-b border-white/10 hover:bg-[#2A2A2A] transition-colors">
            <td className="p-4">
              <Button
                variant="link"
                className="text-white hover:text-blue-400 p-0 h-auto font-normal"
                onClick={() => handleClientClick(client.clientId)}
              >
                {client.clientName}
              </Button>
            </td>
            <td className="p-4 text-right text-gray-400">
              R{client.totalAgreed.toFixed(2)}
            </td>
            <td className="p-4 text-right text-green-400">
              R{client.companyTotal.toFixed(2)}
            </td>
            <td className="p-4 text-center text-blue-400">
              Month {client.currentMonth}
            </td>
            {type === 'potential' ? (
              <td className="p-4">
                <div className="flex justify-center">
                  <span className={`px-3 py-1 rounded-full text-sm ${statusStyles}`}>
                    {status}
                  </span>
                </div>
              </td>
            ) : (
              <>
                <td className="p-4 text-center text-gray-400">
                  {format(new Date(client.firstPaymentDate), 'dd MMM yyyy')}
                </td>
                <td className="p-4">
                  <div className="flex justify-center">
                    <span className={`px-3 py-1 rounded-full text-sm ${statusStyles}`}>
                      {status}
                    </span>
                  </div>
                </td>
              </>
            )}
          </tr>
        );
      })}
    </>
  );
};